import React from 'react'
import { UserMeEditScreen } from 'ui/mypage/user-me-edit-screen'
import { UserDetailScreen } from 'ui/mypage/user-detail-screen'
import { FollowListScreen } from 'ui/mypage/follow-list-screen'
import { PlaceDetailScreen } from 'ui/place/place-detail-screen'
import { PlaceEditScreen } from 'ui/place/place-edit-screen'
import { Place, ProviderType } from 'infra/type'

export type CommonStackParamList = {
  UserMeEditScreen: undefined
  UserDetailScreen: { userId?: number } | undefined
  FollowListScreen: { initialTab: 'follower' | 'following'; userId?: number }
  PlaceDetailScreen: { place: Place; provider: ProviderType }
  PlaceEditScreen: { place: Place }
}

export const renderCommonScreens = (Stack: any) => {
  return [
    <Stack.Screen
      key='UserMeEditScreen'
      name='UserMeEditScreen'
      component={UserMeEditScreen}
    />,
    <Stack.Screen
      key='UserDetailScreen'
      name='UserDetailScreen'
      component={UserDetailScreen}
    />,
    <Stack.Screen
      key='FollowListScreen'
      name='FollowListScreen'
      component={FollowListScreen}
    />,
    <Stack.Screen
      key='PlaceDetailScreen'
      name='PlaceDetailScreen'
      component={PlaceDetailScreen}
    />,
    <Stack.Screen
      key='PlaceEditScreen'
      name='PlaceEditScreen'
      component={PlaceEditScreen}
    />,
  ]
}
